<template >
  <div>
    <div v-if="createStep == 1">
      <top-title
        name="会员权益"
        style="margin: 20px 20px; min-width: 1046px"
      ></top-title>

      <div class="memberPower" style="min-width: 1086px">
        <ul class="itemList">
          <!-- <li class="item">
            <div class="wrap">
              <h4>开卡大礼包</h4>
              <p class="desc">
                针对开卡入会的新会员设置礼包权益，会在非会员开卡的页面露出。
              </p>
              <div class="btns">
                <button class="b1" @click="createStep = 2">管理</button>
                <button class="b2" @click="createStep = 3">创建</button>
              </div>
              <img src="@/assets/images/openacardgiftbag.png" class="img" />
            </div>
          </li> -->
          <li class="item">
            <div class="wrap">
              <h4>新人优惠券</h4>
              <p class="desc1">
                针对未加入店铺会员的新人创建的专属优惠券，将新人快速转化为店铺会员。高效引流，提升店铺店员数量。
              </p>
              <div class="btns">
                <button
                  class="b1"
                  v-zoom="{ from: pageName, name: '新人优惠券管理' }"
                  @click="createStep = 6"
                >
                  管理
                </button>
                <button
                  class="b2"
                  v-zoom="{ from: pageName, name: '新人优惠券创建' }"
                  @click="createStep = 7"
                >
                  创建
                </button>
              </div>
              <img src="@/assets/images/couponfornewcouple.png" class="img" />
            </div>
          </li>
          <li class="item">
            <div class="wrap">
              <h4>会员券</h4>
              <p class="desc">
                支持商家按不同等级设置会员券，会在店铺首页和会员中心页露出。
              </p>
              <div class="btns">
                <button
                  class="b1"
                  v-zoom="{ from: pageName, name: '会员卷管理' }"
                  @click="createStep = 4"
                >
                  管理
                </button>
                <button
                  class="b2"
                  v-zoom="{ from: pageName, name: '会员卷创建' }"
                  @click="createStep = 5"
                >
                  创建
                </button>
              </div>
              <img src="@/assets/images/couponfornewcouple.png" class="img" />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <membershipCoupon
      v-if="createStep == 4"
      :pageName="pageName + '-会员卷'"
      @returnBack="returnBackChange"
    ></membershipCoupon>
    <createMembershipCoupon
      v-if="createStep == 5"
      :pageName="pageName + '-会员券'"
      @returnBack="returnBackChange"
    ></createMembershipCoupon>
    <couponForNewCouple
      v-if="createStep == 6"
      :pageName="pageName + '-新人优惠卷'"
      @returnBack="returnBackChange"
    ></couponForNewCouple>
    <createForNewCouple
      v-if="createStep == 7"
      :pageName="pageName + '-新人优惠券'"
      @returnBack="returnBackChange"
    ></createForNewCouple>
  </div>
</template>

<script>
import topTitle from "../../../components/top-title";
import couponForNewCouple from "./couponcreate_activity_step";
import createForNewCouple from "./create_activity_step";
import createMembershipCoupon from "./create-membership_coupon";
import membershipCoupon from "./membership_coupon";

export default {
  data() {
    return {
      pageName: "忠诚度管理-会员权益",
      createStep: 1,
      activityData: null,
    };
  },
  components: {
    topTitle,
    couponForNewCouple,
    createForNewCouple,
    createMembershipCoupon,
    membershipCoupon,
  },
  created() {},
  methods: {
    //页面跳转
    returnBackChange() {
      this.createStep = 1;
    },
  },
};
</script>

<style scoped lang="scss">
.memberPower {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 980px;
  .itemList {
    display: flex;
    flex-wrap: wrap;
    align-content: baseline;
    box-sizing: border-box;
    height: 80vh;
    padding: 24px 12px 30px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin: 20px 0 50px 0;
    list-style: none;
    .item {
      flex: 1;
      max-width: 25%;
      min-width: 25%;
      box-sizing: border-box;
      padding: 0 16px;
      margin-bottom: 20px;
      .wrap {
        box-sizing: border-box;
        padding: 31px 23px 21px;
        border: 1px solid rgba(238, 238, 238, 0.10196078431372549);
        box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        position: relative;
        @media screen and (max-width: 1370px) {
          height: 220px;
        }
        @media screen and (max-width: 1300px) {
          height: 200px;
        }
        &:hover {
          bottom: 10px;
        }
        h4 {
          margin: 0 0 8px 0;
          color: #333;
          font-size: 16px;
          font-weight: 500;
        }
        .desc1 {
          width: 75%;
          min-height: 56px;
          margin-bottom: 37px;
          line-height: 18px;
          color: #666;
          font-size: 13px;
          @media screen and (max-width: 1323px) {
            margin-bottom: 20px;
          }
        }
        .desc {
          width: 75%;
          min-height: 56px;
          margin-bottom: 37px;
          line-height: 18px;
          color: #666;
          font-size: 13px;
        }
        .img {
          z-index: 1;
          //     @media screen and (max-width:2500px) and (min-width: 1951px) {
          //   margin: -140px 0 0 350px;
          // }
          position: absolute;
          @media screen and (min-width: 2501px) {
            margin: -140px 0 0 260px;
          }
          @media screen and (max-width: 2500px) and (min-width: 1951px) {
            margin: -140px 0 0 250px;
          }
          @media screen and (max-width: 1950px) and (min-width: 1800px) {
            margin: -140px 0 0 210px;
          }
          @media screen and (max-width: 1799px) and (min-width: 1700px) {
            margin: -140px 0 0 210px;
          }
          @media screen and (max-width: 1699px) and (min-width: 1500px) {
            margin: -140px 0 0 220px;
          }
          @media screen and (max-width: 1499px) and (min-width: 1300px) {
            margin: -140px 0 0 150px;
          }
          @media screen and (max-width: 1300px) {
            margin: -140px 0 0 100px;
          }
        }
        .btns {
          z-index: 10;
          display: flex;
          align-items: center;
          button {
            width: 98px;
            height: 32px;
            line-height: 28px;
            background-color: white;
            outline: none;
            cursor: pointer;
            text-align: center;
            transition: all 0.2s;
            border-radius: 3px;
          }
          .b1 {
            z-index: 10;
            margin-right: 8px;
            border: 1px solid #fe4d45;
            color: #fe4d45;
            &:hover {
              background-color: #fe4d45;
              color: #fff;
            }
          }
          .b2 {
            z-index: 10;
            border: 1px solid #cccccc;
            color: #999;
            &:hover {
              border: 1px solid #fe4d45;
              color: #fe4d45;
              background-color: #fff4f4;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1780px) {
    .itemList {
      .item {
        max-width: 33.33%;
        min-width: 33.33%;
      }
    }
  }
}
</style>